import * as React from "react";
import {DynamicDialog, DynamicDialogState} from "shared/controls/Dialogs/core/DynamicDialog";
import {DialogProps} from "shared/controls/Dialogs/core/Dialog";
import {SearchableSelect} from "shared/controls/SingleInputs/SearchableSelect/SearchableSelect";
import {PDFDocument} from "PageBuilder/pagebuilder/PDFDocument";
import {IPDFContainer} from "InternalShared/PageBuilder/Controls/Core/IPDFContainer";

export class FieldPicker extends DynamicDialog<FieldPickerProps,FieldPickerState>{
    static defaultProps: Partial<FieldPickerProps> = {};

    constructor(props: FieldPickerProps) {
        super(props);
        this.state = {
            IsOpen:true,
            SelectedItem:''
        };
    }

    GetAdditionalProperties(): DialogProps {

        return {
            Title:'Select a field',
            EnableApply:true,
            ApplyTitle:'Add',
            OnApply:()=>{this.SendResult(this.props.Page.Form.Fields.find(x=>x.Id==this.state.SelectedItem));}

        }
    }

    SubRenderer(): any{
        let fieldsNotAdded=this.props.Page.Form.Fields.filter(x=>this.props.AlreadySelectedFields.find(y=>y.Id==x.Id)==null);
        return(
            <SearchableSelect Label={'Form field'} Value={this.state.SelectedItem} onChange={e=>this.setState({SelectedItem:e})}>
                {fieldsNotAdded.map(x=>
                    <option key={x.Id} value={x.Id}>{x.Label}</option>

                )}
            </SearchableSelect>
        )
    }



}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface FieldPickerProps {
    AlreadySelectedFields:{Id:string,Label:string}[];
    Page:IPDFContainer;
}

interface FieldPickerState extends DynamicDialogState{
    SelectedItem:string;
}

//#endregion "My Region"